<template>
  <new-consolidation />
</template>

<script>
import NewConsolidation from "@/components/3pl/Operations/Consolidation/NewConsolidation";

export default {
  components: {
    NewConsolidation,
  },
};
</script>

<style></style>
